import axios from "axios";
import { message } from "./resetMessage";
import store from "../store/index";
import router from "../router/index";
import { getStore, removeStore } from "@/untils/storage";
const service = axios.create({
  //baseURL: process.env.BASE_API, // url = base url + request url
  timeout: 30000 // request timeout
});
// request interceptor
service.interceptors.request.use(
  config => {
    if (!config.url.startsWith("/api")) {
        config.url = `${process.env.BASE_API}${config.url}`
    }
    const token = getStore("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    config.headers["Accept"] = "application/json";
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const code = response.data.code;
    if (code === undefined) {
      //文件流
      return response;
    } else {
      if (code === "0000") {
        return response.data.data;
      } else {
        message({
          message: response.data.message,
          type: "error",
          duration: 5 * 1000
        });
      }
    }
  },
  error => {
    /**
     *
     *
     *
     * 处理错误弹窗,相同的弹窗短时间只出现一次
     */
    if (error && error.response) {
      let msg = error.response.data.msg;
      switch (error.response.status) {
        case 400:
          error.msg = msg;
          break;
        case 401:
          error.msg = "未授权，请重新登录";
          removeStore("token");
          router.push({ path: "/" });
          break;
        case 403:
          error.msg = "拒绝访问";
          break;
        case 404:
          error.msg = "请求错误,未找到该资源";
          break;
        case 405:
          error.msg = "请求方法未允许";
          break;
        case 408:
          error.msg = "请求超时";
          break;
        case 417:
          error.msg = "参数错误";
          break;
        case 500:
          error.msg = "服务器端出错";
          break;
        case 501:
          error.msg = "网络未实现";
          break;
        case 502:
          error.msg = "网络错误";
          break;
        case 503:
          error.msg = "服务不可用";
          break;
        case 504:
          error.msg = "网络超时";
          break;
        case 505:
          error.msg = "http版本不支持该请求";
          break;
        default:
          error.msg = `未知错误${error.response.status}`;
      }
    } else {
      error.msg = "连接到服务器失败";
    }
    message({
      message: error.msg,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error.msg);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/untils/request.js